import { render, staticRenderFns } from "./TheTableDonations.vue?vue&type=template&id=45ce7172&scoped=true&"
import script from "./TheTableDonations.vue?vue&type=script&lang=ts&"
export * from "./TheTableDonations.vue?vue&type=script&lang=ts&"
import style0 from "./TheTableDonations.vue?vue&type=style&index=0&id=45ce7172&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ce7172",
  null
  
)

export default component.exports